import { CgBreakpoints } from "../../components/common/cgBreakpoints";


export class InterviewQuestions {
    options = {
        delay: 60000,
        limit: 20
    };

    totalItems = 0;

    // staff
    timer;
    list;
    button;

    constructor() {
        this.init();
    }

    init() {
        this.list = $('.question-list');

        this.searchCustom();

        if (!this.list.length || this.list.length > 1 || !this.list.data('src')) {
            return;
        }

        this.button = $('[data-container="question-list"]');

        this.timer = window.setInterval(() => {
            this.ajaxAction('update');
        }, this.options.delay);

        this.bindEvents();
    }

    bindEvents() {
        this.button.on('click', (e) => {
            e.preventDefault();
            this.ajaxAction('load');
        });
    }

    ajaxAction(mode) {
        let href = '';

        this.list.addClass('question-list--loading');

        if (mode === 'update') {
            href = this.list.data('src');
        }

        if (mode === 'load') {
            href = this.button.prop('href');
        }

        $.ajax({
            url: href,
            method: 'GET',
            data: {
                fragment: true
            }
        })
            .done((res) => {
                if (typeof res == "string") {
                    res = JSON.parse(res);
                }

                if ((res.errors === undefined)
                    || res.errors.length) {
                    this.onError(res.errors);
                    return;
                }

                if (mode === 'update') {
                    if (!this.wasUpdated(res)) {
                        this.totalItems = res.data.totalItems;
                        return;
                    }

                    this.updateItems(res);
                }

                if (mode === 'load') {
                    this.loadItems(res);
                }

                if (!this.isMobile() && this.hasNewPage(res)) {
                    this.reloadWindow();
                }
            })
            .fail((err) => this.onError(err))
            .always(() => this.onAlways());
    }

    updateItems(res) {
        this.list.html(res.data.html);
        this.totalItems = res.data.totalItems;
    }

    loadItems(res) {
        this.list.append(res.data.html);
        res.data.nextPageUrl ? this.button.prop('href', res.data.nextPageUrl) : this.button.remove();
    }

    onError(err) {
        console.debug('Question Error ', err);
        this.list.addClass('question-list--error');
        this.stopUpdate();
    }

    onAlways() {
        if (!this.list.is('.question-list--error')) {
            this.list.removeClass('question-list--loading');
        }
    }

    stopUpdate() {
        window.clearInterval(this.timer);
    }

    wasUpdated(res) {
        return 0 < this.totalItems && this.totalItems < res.data.totalItems;
    }

    hasNewPage(res) {
        return res.data.totalItems !== 1 && res.data.totalItems % options.limit >= 1;
    }

    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }

    reloadWindow() {
        window.location.reload(true);
    }

    searchCustom() {
        let hash = window.location.hash;
        if (hash && hash.startsWith('#question_', 0)) {
            hash = hash.replace('#question_', '/tmdcontentinterview/question/');
            $.ajax({
                url: hash,
                method: 'GET',
                data: {}
            })
                .done((res) => {
                    $('#featured-question').html(res);
                })
                .fail((err) => this.onError(err));
        }
    }
}
